import Input from 'components/Input';
import styles from './styles.module.scss';
import { FC, Props } from './typings';
import { useEffect, useMemo, useRef, useState } from 'react';
import { ITag } from 'dto/ITag';
import tagsService from 'api/tagsService';
import InputWithRightIcon from 'components/InputWithRightIcon';
import TerytService from 'api/TerytService';
import { useDebounce } from 'use-debounce';
import { useOnClickOutside } from 'usehooks-ts';

const SearchAddress: FC<Props> = ({
  isError = '',
  cityId,
  onChange,
  defaultValue,
  onBlur,
}) => {
  const [value, setValue] = useState(defaultValue.toString() ?? '');
  const [search, setSearch] = useState('');
  const [searchList, setSearchList] = useState<any[]>([]);
  //
  const [debounced] = useDebounce(search, 300);
  //
  const { data: zipData } = TerytService.useGetStreet(cityId, debounced);
  const zipCodes: any[] = useMemo(() => zipData?.data ?? [], [zipData]);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    const list = zipCodes.map((zip) => zip);

    setSearchList(list);
  }, [search, zipCodes]);

  const handleClick = (zip: any) => {
    setValue(zip.Name);
    onChange(zip.Name, zip.Id);
    setSearchList([]);
  };

  useEffect(() => {
    setValue(defaultValue.toString());
  }, [defaultValue]);

  const outsideRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    if (focused) {
      setFocused(false);
    }
  });

  return (
    <div ref={outsideRef} className={`${styles.wrapper}`}>
      <InputWithRightIcon
        value={value}
        isError={isError}
        onFocus={() => {
          setFocused(true);
        }}
        onBlur={() => {
          onBlur?.();
        }}
        onChange={(text) => {
          setValue(text);
          setSearch(text);
        }}
        label="Ulica"
      />
      {!!searchList.length && !!value.length && focused && (
        <div className={styles.list}>
          <div className={styles.listWrapper}>
            {searchList.map((zip: any) => (
              <div
                onClick={() => handleClick(zip)}
                key={zip}
                className={styles.box}
              >
                {zip.Name}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchAddress;
